/* eslint-disable */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";

import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import { reactSelectStyle } from "Config/Config";
import { assetImages } from "constants";
import DoctorDetailsCard from "../DoctorDetailsCard/DoctorDetailsCard";
import PatientDetailsCard from "../PatientDetailsCard/PatientDetailsCard";
import ClinicDetailsCard from "../ClinicDetailsCard/ClinicDetailsCard";
import ProductDetailsCard from "../ProductDetailsCard/ProductDetailsCard";

const SaveImmunizationPopup = ({
  afterActionClose = () => {},
  selectedImmunizationId = null,
  setSelectedImmunizationId = () => {},
  patientObj = null,
  doctorObj = null,
  clinicObj = null,
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // States for all input fields
  const [immunizationTitle, setImmunizationTitle] = useState("");
  const [vaccine, setVaccine] = useState(null);
  const [manufracturer, setManufracturer] = useState("");
  const [doseNumber, setDoseNumber] = useState("");
  const [dateAdministrated, setDateAdministrated] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [facility, setFacility] = useState(null);
  const [batchNumber, setBatchNumber] = useState("");
  const [expirationDate, setExpirationDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [nextDose, setNextDose] = useState(null);
  const [nextDoseDueDate, setNextDoseDueDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [sideEffects, setSideEffects] = useState("");
  const [comments, setComments] = useState("");
  const [assignTo, setAssignTo] = useState(null);
  const [doctor, setDoctor] = useState(null);

  // Options for react-select fields
  const [nextDoseOptions, setNextDoseOptions] = useState([]);

  const [isSaving, setIsSaving] = useState(false);
  // Add loading state for details
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  // Async load options for assignee
  const loadAssineeOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=PATIENT`;

      const reponse = await getData(requestUrl);
      return reponse.data;
    } catch (error) {
      return [];
    }
  };

  // Async load options for doctor
  const loadDoctorOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=DOCTOR`;

      const reponse = await getData(requestUrl);
      return reponse.data;
    } catch (error) {
      return [];
    }
  };

  // async load vaccine options
  const loadVaccineOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_PRODUCTS_LIST +
        `?token=${token}&title=${inputValue}`;

      const response = await getData(requestUrl);

      return response.data;
    } catch (error) {
      console.log(error.message);
      return [];
    }
  };

  // async load manufacturer options
  const loadFacilityOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_BY_SEARCH +
        `?token=${token}&filtername=${inputValue}`;

      const response = await getData(requestUrl);

      return response.data;
    } catch (error) {
      console.log(error.message);
      return [];
    }
  };

  // Get immunization details
  const getImmunizationDetails = async () => {
    try {
      setIsLoadingDetails(true); // Start loading
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_IMMUNIZATION_BY_ID +
        `/${selectedImmunizationId}?token=${token}`;

      console.log("requestUrl in get immunization details------->", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in get immunization details------->", response);

      if (response.status) {
        setImmunizationTitle(response.data.title);
        const immunizationData = response.data;

        if (immunizationData.vaccinedetails) {
          setVaccine(immunizationData.vaccinedetails);
        }
        setManufracturer(immunizationData.manufracturer);
        setBatchNumber(immunizationData.batchnumber);
        setDoseNumber(immunizationData.dosenumber);
        setExpirationDate(
          immunizationData.expirationdate
            ? new Date(immunizationData.expirationdate)
                .toISOString()
                .split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        setDateAdministrated(
          immunizationData.dateadministered
            ? new Date(immunizationData.dateadministered)
                .toISOString()
                .split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        if (immunizationData.clinicdetails) {
          setFacility(immunizationData.clinicdetails);
        }
        setNextDose(
          immunizationData.nextdoseduedate === ""
            ? { value: true, label: "Taken" }
            : { value: false, label: "Not Taken" }
        );
        setNextDoseDueDate(
          immunizationData.nextdoseduedate
            ? new Date(immunizationData.nextdoseduedate)
                .toISOString()
                .split("T")[0]
            : new Date().toISOString().split("T")[0]
        );
        setSideEffects(immunizationData.sideeffects);
        setComments(immunizationData.comments);
        if (immunizationData.assigntodetails) {
          setAssignTo(immunizationData.assigntodetails);
        }
        if (immunizationData.doctordetails) {
          setDoctor(immunizationData.doctordetails);
        }
      }
      setIsLoadingDetails(false); // End loading
    } catch (error) {
      setIsLoadingDetails(false); // End loading on error
      console.log(error.message);
    }
  };

  // Save immunization
  const saveImmunizationHandler = async () => {
    try {
      setIsSaving(true);
      const apiData = {
        title: immunizationTitle,
        vaccineid: vaccine ? vaccine.value : null,
        manufracturer: manufracturer,
        clinicid: facility ? facility.value : null,
        dosenumber: doseNumber,
        dateadministered: new Date(dateAdministrated).toISOString(),
        batchnumber: batchNumber,
        nextdoseduedate:
          nextDose?.value === true
            ? ""
            : new Date(nextDoseDueDate).toISOString(),
        sideeffects: sideEffects,
        comments: comments,
        assignto: assignTo ? assignTo.value : null, // patient
        doctorid: doctor ? doctor.value : null,
      };

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (selectedImmunizationId) {
        requestUrl +=
          url.API_UPDATE_IMMUNIZATION +
          `/${selectedImmunizationId}?token=${token}`;
        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_IMMUNIZATION + `?token=${token}`;
        response = await postData(requestUrl, apiData);
      }

      setIsSaving(false);

      if (response.status) {
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveImmunizationOffCanvas")
        ).hide();
        resetHandler();
        afterActionClose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Reset  all states
  const resetHandler = () => {
    setImmunizationTitle("");
    setVaccine(null);
    setManufracturer("");
    setDoseNumber("");
    setDateAdministrated(new Date().toISOString().split("T")[0]);
    setBatchNumber("");
    setNextDose(null);
    setNextDoseDueDate("");
    setSideEffects("");
    setComments("");
    setAssignTo(patientObj);
    setDoctor(doctorObj);
    setFacility(clinicObj);
    setSelectedImmunizationId(null);
  };

  useEffect(() => {
    if (selectedImmunizationId) {
      getImmunizationDetails();
    }
  }, [selectedImmunizationId]);

  // Fetch facility and next dose options
  useEffect(() => {
    setNextDoseOptions([
      { value: true, label: "Taken" },
      { value: false, label: "Not Taken" },
    ]);
  }, []);

  useEffect(() => {
    if (patientObj && !selectedImmunizationId) {
      setAssignTo(patientObj);
    }
  }, [patientObj, selectedImmunizationId]);

  useEffect(() => {
    if (doctorObj && !selectedImmunizationId) {
      setDoctor(doctorObj);
    }
  }, [doctorObj, selectedImmunizationId]);

  useEffect(() => {
    if (clinicObj && !selectedImmunizationId) {
      setFacility(clinicObj);
    }
  }, [clinicObj, selectedImmunizationId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveImmunizationOffCanvas"
      aria-labelledby="saveImmunizationOffCanvas"
    >
      {/* Loader overlay while fetching details */}
      {isLoadingDetails && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary icon-md">
              vaccines
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Save Vaccination
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update immunization details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form onSubmit={(e) => e.preventDefault()}>
            {/* --- New Top Row: Patient and Administration(Doctor) --- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold">
                {t("Patient & Administrator")}
              </h5>

              <div className="row">
                <div className="col-md-6">
                  <label className="d-block fw-semibold mb-2">
                    Patient <span className="text-danger fw-bold">*</span>
                  </label>
                  <AsyncSelect
                    isClearable
                    name="patient"
                    loadOptions={loadAssineeOptions}
                    defaultOptions={false}
                    cacheOptions={false}
                    placeholder="Select Patient"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={assignTo}
                    onChange={setAssignTo}
                  />
                  {assignTo ? <PatientDetailsCard patient={assignTo} /> : null}
                </div>
                <div className="col-md-6">
                  <label className="d-block fw-semibold mb-2">
                    Doctor <span className="text-danger fw-bold">*</span>
                  </label>
                  <AsyncSelect
                    isClearable
                    name="doctor"
                    loadOptions={loadDoctorOptions}
                    defaultOptions={false}
                    cacheOptions={false}
                    placeholder="Select Doctor"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    value={doctor}
                    onChange={setDoctor}
                  />
                  {doctor ? <DoctorDetailsCard doctor={doctor} /> : null}
                </div>
              </div>
            </div>

            {/* --- Vaccine Information --- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold">{t("Vaccine Information")}</h5>
              <div className="form-group mb-3">
                <label className="d-block fw-semibold mb-2">
                  Vaccination Title{" "}
                  <span className="text-danger fw-bold">*</span>
                </label>
                <input
                  type="text"
                  name="title"
                  value={immunizationTitle}
                  onChange={(e) => setImmunizationTitle(e.target.value)}
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter Vaccination Title"
                />
              </div>

              {/* Vaccine select and details card */}
              <div className="form-group mb-3">
                <label className="d-block fw-semibold mb-2">
                  Vaccine <span className="text-danger fw-bold">*</span>
                </label>
                <AsyncSelect
                  isClearable
                  name="vaccine"
                  loadOptions={loadVaccineOptions}
                  defaultOptions={false}
                  cacheOptions={false}
                  placeholder="Select Vaccine"
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  value={vaccine}
                  onChange={(option) => {
                    setVaccine(option);
                    setManufracturer(option?.companyname);
                  }}
                />

                {/* Vaccine details card */}

                {vaccine ? <ProductDetailsCard product={vaccine} /> : null}
              </div>

              {/* Manufacturer, Lot Number, Expiration Date */}
              <div className="row mt-3">
                <div className="col">
                  <label className="d-block fw-semibold mb-2">
                    Manufacturer <span className="text-danger fw-bold">*</span>
                  </label>
                  <input
                    type="text"
                    name="manufacturer"
                    value={manufracturer}
                    onChange={(e) => setManufracturer(e.target.value)}
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Enter Manufacturer"
                  />
                </div>
                <div className="col">
                  <label className="d-block fw-semibold mb-2">
                    Lot Number <span className="text-danger fw-bold">*</span>
                  </label>
                  <input
                    type="text"
                    name="lotNumber"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Enter Lot Number"
                    value={batchNumber}
                    onChange={(e) => setBatchNumber(e.target.value)}
                  />
                </div>
                <div className="col">
                  <label className="d-block fw-semibold mb-2">
                    Expiration Date{" "}
                    <span className="text-danger fw-bold">*</span>
                  </label>
                  <input
                    type="date"
                    name="expirationDate"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    value={expirationDate}
                    onChange={(e) => setExpirationDate(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* --- Administration Details --- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold">
                {t("Administration Details")}
              </h5>
              <div className="row">
                <div className="col">
                  <label className="d-block fw-semibold mb-2">
                    Date Administrated{" "}
                    <span className="text-danger fw-bold">*</span>
                  </label>
                  <input
                    type="date"
                    name="dateAdministrated"
                    value={dateAdministrated}
                    onChange={(e) => setDateAdministrated(e.target.value)}
                    className="form-control fs-sm shadow-none border border-gray-300"
                  />
                </div>
                <div className="col">
                  <label className="d-block fw-semibold mb-2">
                    Dose Number
                  </label>
                  <input
                    type="number"
                    name="doseNumber"
                    value={doseNumber}
                    onChange={(e) => setDoseNumber(e.target.value)}
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Enter Dose Number"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col">
                  <label className="d-block fw-semibold mb-2">
                    Next Dose <span className="text-danger fw-bold">*</span>
                  </label>
                  <Select
                    isClearable
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder="Select Next Dose"
                    options={nextDoseOptions}
                    value={nextDose}
                    onChange={setNextDose}
                  />
                </div>
                <div className="col">
                  <label className="d-block fw-semibold mb-2">
                    Next Dose Due Date
                  </label>
                  <input
                    type="date"
                    name="nextDoseDueDate"
                    value={nextDoseDueDate}
                    onChange={(e) => setNextDoseDueDate(e.target.value)}
                    className="form-control fs-sm shadow-none border border-gray-300"
                  />
                </div>
              </div>

              <div className="form-group mt-3">
                <label className="d-block fw-semibold mb-2">Facility</label>
                <AsyncSelect
                  isClearable
                  name="facility"
                  loadOptions={loadFacilityOptions}
                  defaultOptions={false}
                  cacheOptions={false}
                  placeholder="Select Facility"
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  value={facility}
                  onChange={setFacility}
                />
                {facility ? <ClinicDetailsCard clinic={facility} /> : null}
              </div>
            </div>

            {/* --- Additional Information --- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold">
                {t("Additional Information")}
              </h5>
              <div className="form-group mb-4">
                <label className="d-block fw-semibold mb-2">Side Effects</label>
                <textarea
                  name="sideEffects"
                  id="sideEffects"
                  rows="5"
                  placeholder="Enter Side Effects"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  value={sideEffects}
                  onChange={(e) => setSideEffects(e.target.value)}
                ></textarea>
              </div>

              <div className="form-group mb-4">
                <label htmlFor="comments" className="d-block fw-semibold mb-2">
                  Comments
                </label>
                <textarea
                  name="comments"
                  id="comments"
                  rows="5"
                  placeholder="Enter Comments"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                ></textarea>
              </div>
            </div>

            <div
              className={
                vaccine &&
                manufracturer &&
                doseNumber &&
                dateAdministrated &&
                batchNumber &&
                nextDose
                  ? "group_btnOuter d-flex justify-content-end pt-3 border-top mt-auto"
                  : "d-none"
              }
            >
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={saveImmunizationHandler}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>
                    Save Vaccination
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveImmunizationPopup;
